export default {
    data() {
        return {
            maxlength: null,
            pickerOptions: {
                shortcuts: [
                  {
                    text: "时间不限",
                    onClick(picker) {
                      picker.$emit("pick", ["", ""]);
                    },
                  },
                  {
                    text: "一天内",
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                      picker.$emit("pick", [start, end]);
                    },
                  },
                  {
                    text: "一周内",
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit("pick", [start, end]);
                    },
                  },
                  {
                    text: "一月内",
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit("pick", [start, end]);
                    },
                  },
                  {
                    text: "一年内",
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                      picker.$emit("pick", [start, end]);
                    },
                  },
                ],
              },
        }
    },
    methods: {
        //限制字数
        wordLimit(content, refname, refMessage, maxLength, maxMessage, minLength, minMessage) {
            maxLength = this.maxLength || maxLength
            if (content != "" && /^ *$/.test(content)) {
                //判断输入的都是空格,不允许发送
                this.$message.info(refMessage ? refMessage : '请输入内容')
                this.$refs[refname].clear();
                return
            }
            if (content.length == maxLength) {
                this.$message.warning(maxMessage ? maxMessage : "最多可输入" + maxLength + "个字");
                return;
            }
            return true
        },
    },
}